import React from 'react'
import s from './QRCode.module.scss'
import cx from 'classnames'

import Config from 'scripts/util/Config'
import QRCodeSVG from 'qrcode-svg'


QRCode.defaultProps = {

};

export default function QRCode({ className = '' }) {

  const __html = (
		new QRCodeSVG({
      content: `${Config.url()}`,
      padding: 0,
      color: `currentColor`,
      background: `none`,
      container: `none`,
      ecl: `L`
    }).svg()
	)

  return (
    <svg
      className={cx(s.QRCode, className)}
			viewBox="0 0 256 256"
			dangerouslySetInnerHTML={{
				__html
			}}
		/>
  )
}
